import { atom } from 'jotai';

/** Controls the post-upgrade Evidence onboarding dialog (not modal-queue managed). */
export const evidencePostUpgradeOnboardingModalOpenAtom = atom(false);

/**
 * When true, the user chose "See what's new" on {@link ModalId.EVIDENCE_POST_UPGRADE_WELCOME_POPUP}.
 * The welcome stays the current queued modal until onboarding closes; then the client completes
 * seen state + backend viewed so the queue can advance.
 */
export const evidencePostUpgradeWelcomeDeferQueueUntilAfterOnboardingAtom = atom(false);
